import { Link } from 'react-router-dom';

import { ContactForm } from '@/components/contact-form';

const FAQ = [
  {
    q: 'How do I add my partner?',
    a: 'Tap “Invite co-parent” and scan the QR code in person. The key exchanges directly between devices.',
  },
  {
    q: 'My co-parent’s entries are not showing up.',
    a: 'Syncing requires a network connection. Opening Bramble on both phones forces an immediate sync.',
  },
  {
    q: 'Can you recover my data?',
    a: 'No. Your records are encrypted on your devices and cannot be read or restored by us. Keep an encrypted device backup.',
  },
  {
    q: 'Is there an Android version?',
    a: 'Not yet. Bramble is currently iOS-only, though the sync protocol supports future platforms.',
  },
];

export default function SupportPage() {
  return (
    <div className="container py-16 sm:py-24">
      <header className="max-w-[62ch]">
        <p className="kicker">Support</p>
        <h1 className="mt-4 text-[clamp(2.4rem,6vw,3.8rem)] leading-[1.02]">
          Need help? Send us a message.
        </h1>
        <p className="mt-6 text-lg leading-relaxed text-foreground/80">
          We do not use accounts or ticketing systems. Submissions go straight to our inbox.
        </p>
      </header>

      <div className="hairline my-12" />

      <div className="grid gap-16 lg:grid-cols-[minmax(0,1fr)_minmax(0,22rem)] lg:gap-20">
        <section aria-labelledby="contact-heading">
          <h2 id="contact-heading" className="sr-only">
            Contact form
          </h2>
          <div className="max-w-xl">
            <ContactForm />
          </div>
        </section>

        <aside className="space-y-10">
          <section aria-labelledby="faq-heading">
            <h2 id="faq-heading" className="kicker">
              Before you write
            </h2>
            <dl className="mt-5 space-y-6">
              {FAQ.map((item) => (
                <div key={item.q} className="border-t border-border pt-5">
                  <dt className="font-display text-lg font-semibold leading-snug">{item.q}</dt>
                  <dd className="mt-1.5 text-[0.95rem] leading-relaxed text-muted-foreground">
                    {item.a}
                  </dd>
                </div>
              ))}
            </dl>
          </section>

          <section className="rounded-lg border border-border bg-card p-6">
            <h2 className="font-display text-lg font-semibold">Data safety note</h2>
            <p className="mt-2 text-[0.95rem] leading-relaxed text-muted-foreground">
              Please do not include medical details about your child in support messages. See the{' '}
              <Link to="/privacy">privacy policy</Link>.
            </p>
          </section>
        </aside>
      </div>
    </div>
  );
}
